var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.20078 1.20312C1.81278 1.20312 0.804688 2.03491 0.804688 3.17891C0.804688 4.32691 1.83678 5.19531 3.20078 5.19531C4.58878 5.19531 5.59688 4.34747 5.59688 3.15547C5.53288 2.00747 4.54478 1.20312 3.20078 1.20312ZM1.20078 5.99922C0.980781 5.99922 0.800781 6.17922 0.800781 6.39922V17.9992C0.800781 18.2192 0.980781 18.3992 1.20078 18.3992H5.20078C5.42078 18.3992 5.60078 18.2192 5.60078 17.9992V6.39922C5.60078 6.17922 5.42078 5.99922 5.20078 5.99922H1.20078ZM7.20078 5.99922C6.98078 5.99922 6.80078 6.17922 6.80078 6.39922V17.9992C6.80078 18.2192 6.98078 18.3992 7.20078 18.3992H10.8008C11.0216 18.3992 11.2008 18.22 11.2008 17.9992V11.9992V11.8992V11.7992C11.2008 10.8512 11.929 10.079 12.857 10.007C12.905 9.99903 12.9528 9.99922 13.0008 9.99922C13.0488 9.99922 13.0965 9.99903 13.1445 10.007C14.0725 10.079 14.8008 10.8512 14.8008 11.7992V17.9992C14.8008 18.22 14.98 18.3992 15.2008 18.3992H18.8008C19.0208 18.3992 19.2008 18.2192 19.2008 17.9992V11.1992C19.2008 8.61122 17.8124 5.99922 14.7164 5.99922C13.3084 5.99922 12.2448 6.54331 11.6008 6.99531V6.39922C11.6008 6.17922 11.4208 5.99922 11.2008 5.99922H7.20078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinN);
export default __webpack_public_path__ + "static/media/linkedinN.4dda23c0c72fb1228477cdc5c7da37c7.svg";
export { ForwardRef as ReactComponent };